import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-achizitii-si-licitatii',
  templateUrl: './achizitii-si-licitatii.component.html',
  styleUrls: ['./achizitii-si-licitatii.component.scss']
})
export class AchizitiiSiLicitatiiComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
